/*eslint-env jquery*/
import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { toastr } from 'react-redux-toastr'
import MySweetAlert from '../Shared/MySweetAlert'
import Loading from '../Shared/Loading'
import Select from 'react-select'
import { customersService } from '../../_services/customers.service'
import customerTypes from '../../_constants/customerTypes'
import CustomerTypeSelect from '../Shared/CustomerTypeSelect'

// Import React Table
import matchSorter from 'match-sorter'
import ReactTable from 'react-table'

import { Input } from 'antd'
import { FaPlus } from 'react-icons/fa'
import { FiEdit, FiCheckCircle, FiCircle } from 'react-icons/fi'
import { FiTrash2 } from 'react-icons/fi'
import { GrChat } from 'react-icons/gr'

import FormModal from './FormModal'
import SmsModal from './SmsModal'

const initialModel = {
  title: '',
  gender: '',
  firstName: '',
  lastName: '',
  email: '',
  mobile: '',
  customerTypeIsLegal: false,
  customerType: '',
  customerSubType: '',
  dateOfBirth: '',
  economicCode: '',
  registrationNumber: '',
  nationalCode: '',
  sendSms: true,
  brands: []
}

class Customers extends Component {
  constructor(props, context) {
    super(props, context)

    var pageSize = parseInt(localStorage.getItem('pageSizeForCustomers'), 0)
    this.state = {
      data: [],
      loading: true,
      confirmDeleteShow: false,
      model: {},
      pageSize: pageSize ? pageSize : 10,
      FormDialogShow: false,
      smsModelId: undefined,
      smsDialogShow: false
    }

    this.getData()
  }

  handleSweetAlertHide = () => {
    this.setState({ confirmDeleteShow: false })
  }

  getData() {
    customersService
      .getAll()
      .then(res => {
        // console.log(res.data)
        let pageSize = res.data.length
        this.setState({ data: res.data, pageSize: pageSize, loading: false })
      })
      .catch(error => {
        this.handleError(error)
      })
  }

  handleError(error) {
    this.setState({ loading: false })
    console.log(error)
  }

  handleDelete = e => {
    let _model = this.state.data[e]
    // console.log(_model);

    this.setState({ confirmDeleteShow: true, model: _model })
  }

  handleConfirmDelete = () => {
    this.setState({ loading: true, confirmDeleteShow: false })
    // // console.log(this.state.model );
    customersService
      .delete(this.state.model.id)
      .then(res => {
        toastr.success('حذف مشتری ', 'مشتری با موفقیت حذف شد')
        this.getData()
      })
      .catch(error => {
        this.handleError(error)
      })
  }

  handleCreateDialogShow = () => {
    this.setState({ model: initialModel, FormDialogShow: true })
  }

  handleEditDialogShow = e => {
    this.setState({ modelId: e, FormDialogShow: true })
  }

  handleSmsDialogShow = e => {
    this.setState({ smsModelId: e, smsDialogShow: true })
  }

  render() {
    const {
      data,
      modelId,
      pageSize,
      FormDialogShow,
      smsModelId,
      smsDialogShow
    } = this.state
    return (
      <div>
        <div className="row table-container" style={{ marginTop: 0 }}>
          <ReactTable
            data={data}
            filterable
            previousText="صفحه قبل"
            nextText="صفحه بعد"
            loadingText="در حال بارگذاری ..."
            noDataText="نتیجه ای یافت نشد"
            pageText="صفحه"
            ofText="از"
            rowsText="تعداد نمایش"
            getTableProps={() => ({ style: { display: 'block' } })} // direction: rtl fix
            defaultFilterMethod={(filter, row) =>
              String(row[filter.id]) === filter.value
            }
            columns={[
              {
                Header: 'ردیف',
                id: 'row',
                maxWidth: 50,
                filterable: false,
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                },
                className: 'numberFa',
                Cell: row => {
                  return row.index + 1
                }
              },
              {
                Header: 'نوع مشتری',
                accessor: 'customerType',
                id: 'customerType',
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  overflow: 'visible',
                  justifyContent: 'center'
                },

                filterMethod: (filter, row) => {
                  if (filter.value === null || filter.value === undefined) {
                    return true
                  }
                  if (row[filter.id] === filter.value) {
                    return true
                  }
                  //return row[filter.id] === filter.value;
                },
                Cell: row =>
                  customerTypes.filter(
                    el => el.value === row.original.customerType
                  )[0].label,
                Filter: ({ onChange }) => (
                  <CustomerTypeSelect
                    isClearable
                    placeholder=""
                    onChange={event => onChange(event)}
                  />
                )
              },
              {
                Header: 'عنوان',
                accessor: 'title',
                id: 'title',
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                },
                filterMethod: (filter, rows) =>
                  matchSorter(rows, filter.value, { keys: ['title'] }),
                filterAll: true,
                Filter: ({ onChange }) => (
                  <Input
                    placeholder=""
                    allowClear
                    onChange={event => onChange(event.target.value)}
                  />
                )
              },
              {
                Header: 'نام و نام خانوادگی',
                accessor: 'fullName',
                id: 'fullName',
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                },
                filterMethod: (filter, rows) =>
                  matchSorter(rows, filter.value, { keys: ['fullName'] }),
                filterAll: true,
                Filter: ({ onChange }) => (
                  <Input
                    placeholder=""
                    allowClear
                    onChange={event => onChange(event.target.value)}
                  />
                )
              },
              // {
              //   Header: "ایمیل",
              //   accessor: "email",
              //   id: "email",
              //   style: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
              //   filterMethod: (filter, rows) =>
              //     matchSorter(rows, filter.value, { keys: ["email"] }),
              //   filterAll: true,
              //   Filter: ({ onChange }) =>
              //     <Input placeholder="" allowClear onChange={event => onChange(event.target.value)} />
              // },
              {
                Header: 'شماره موبایل',
                accessor: 'mobile',
                id: 'mobile',
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                },
                className: 'numberFa',
                filterMethod: (filter, rows) =>
                  matchSorter(rows, filter.value, {
                    keys: ['mobile'],
                    threshold: matchSorter.rankings.CONTAINS
                  }),
                filterAll: true,
                Filter: ({ onChange }) => (
                  <Input
                    placeholder=""
                    allowClear
                    onChange={event => onChange(event.target.value)}
                  />
                )
              },
              // {
              //   Header: "کد فعال سازی",
              //   accessor: "activationCode",
              //   id: "activationCode",
              //   style: { display: 'flex', alignItems: 'center', overflow: 'visible', justifyContent: 'center' },
              //   filterable: false,
              //   filterMethod: (filter, rows) =>
              //     matchSorter(rows, filter.value, { keys: ["customer.activationCode"], threshold: matchSorter.rankings.CONTAINS }),
              //   filterAll: true,
              //   Filter: ({ filter, onChange }) =>
              //     <Input placeholder="" allowClear onChange={event => onChange(event.target.value)} />,

              //   Cell: row => (
              //     row.original.activationCode
              //   )
              // },
              {
                Header: 'ارسال پیامک',
                accessor: d => d.sendSms,
                id: 'sendSms',
                sortable: false,
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                },
                width: 140,
                Cell: row => (
                  <div>
                    {row.original.sendSms ? (
                      <FiCheckCircle size="24px" color="#4caf50" />
                    ) : (
                      <FiCircle size="24px" color="#f44336" />
                    )}
                  </div>
                ),
                filterMethod: (filter, row) => {
                  console.log(filter)
                  if (filter.value === null || filter.value === undefined) {
                    return true
                  }
                  if (filter.value.value === false) {
                    return row.sendSms === filter.value.value
                  }
                  return row.sendSms > 0
                },
                Filter: ({ onChange }) => (
                  <Select
                    isClearable
                    placeholder=""
                    options={[
                      { value: true, label: 'فعال' },
                      { value: false, label: 'غیر فعال' }
                    ]}
                    onChange={event => onChange(event)}
                  />
                )
              },
              {
                Header: 'مشاهده پیامها',
                accessor: 'id',
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                },
                width: 100,
                sortable: false,
                filterable: false,
                Cell: row => (
                  <div>
                    <a
                      onClick={() => this.handleSmsDialogShow(row.original.id)}
                      className="btn btn-sm btn-simple btn-info bmd-ripple bmd-flat-btn">
                      <GrChat size="24px" className="sms-icon-svg" />
                    </a>
                  </div>
                )
              },
              {
                Header: 'ویرایش',
                accessor: 'id',
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                },
                width: 150,
                sortable: false,
                Filter: ({ filter, onChange }) => (
                  <a
                    onClick={() => this.handleCreateDialogShow()}
                    className="btn btn-primary react-table-add-btn">
                    <span>
                      <FaPlus size="16px" />
                      <span>افزودن مشتری جدید</span>
                    </span>
                  </a>
                ),
                Cell: row => (
                  <div>
                    <a
                      onClick={() => this.handleEditDialogShow(row.original.id)}
                      className="btn btn-sm btn-simple btn-success bmd-ripple bmd-flat-btn"
                      rel="tooltip"
                      data-original-title="ویرایش">
                      <FiEdit size="24px" />
                    </a>
                    <a
                      onClick={() => this.handleDelete(row.index)}
                      className="btn btn-sm btn-simple btn-danger bmd-ripple bmd-flat-btn delete-btn"
                      data-original-title="حذف"
                      rel="tooltip">
                      <FiTrash2 size="24px" />
                    </a>
                  </div>
                )
              }
            ]}
            defaultPageSize={10}
            showPagination={data && data.length > pageSize}
            pageSize={pageSize}
            onPageSizeChange={pageSize => {
              localStorage.setItem('pageSizeForCustomers', pageSize)
            }}
            className="-striped -highlight">
            {(state, makeTable, instance) => {
              let recordsInfoText = ''

              const {
                filtered,
                pageRows,
                pageSize,
                sortedData,
                page,
                data
              } = state

              if (sortedData && sortedData.length > 0) {
                let isFiltered = filtered.length > 0

                let totalRecords = sortedData.length

                let totalDataCount = data.length

                let recordsCountFrom = page * pageSize + 1

                let recordsCountTo = recordsCountFrom + pageRows.length - 1

                if (isFiltered)
                  recordsInfoText = `${totalRecords} از ${totalDataCount} نتیجه فیلتر شده`
                else recordsInfoText = `تعداد کل: ${totalRecords}`
              } else recordsInfoText = 'نتیجه ای یافت نشد'

              return (
                <>
                  <div className="row text-right">
                    <div className="col-sm-12">
                      <span className="records-info">{recordsInfoText}</span>
                    </div>
                    <br />
                    <br />
                  </div>
                  {makeTable()}
                </>
              )
            }}
          </ReactTable>
        </div>

        <FormModal
          itemsInitialValues={initialModel}
          id={modelId}
          show={FormDialogShow}
          // onSubmit={() => props.onSubmit()}
          onClose={() =>
            this.setState({ FormDialogShow: false, modelId: undefined })
          }
        />

        <SmsModal
          id={smsModelId}
          show={smsDialogShow}
          onClose={() =>
            this.setState({ smsDialogShow: false, smsModelId: undefined })
          }
        />

        <MySweetAlert
          show={this.state.confirmDeleteShow}
          onCancel={this.handleSweetAlertHide}
          onConfirm={this.handleConfirmDelete}
          title={
            'آیا از حذف مشتری  ' +
            (this.state.model.firstName ? this.state.model.firstName : '') +
            ' ' +
            (this.state.model.lastName ? this.state.model.lastName : '') +
            ' مطمئن هستید؟'
          }
        />

        {this.state.loading ? <Loading /> : ''}
      </div>
    )
  }
}

export default Customers
